export function removeDiacritics(string?: string): string {
  if (!string) return '';
  return string.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}

export function toFilterString(string?: string): string {
  if (!string) return '';
  return removeDiacritics(string.trim().toLowerCase());
}

function textContainsSubString(query: string, item?: string) {
  return toFilterString(item).includes(toFilterString(query));
}

export function itemsContainText(query: string, items: (string | undefined)[]) {
  return items.some(item => textContainsSubString(query, item));
}

export namespace StringUtil {
  export function upperCaseFirstCharacter(string: string) {
    return string.length ? string[0].toUpperCase() + string.slice(1) : '';
  }
}

export function isValidEmail(email: string) {
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return re.test(email.trim());
}
